import { apiHolder } from 'api';
import qs from 'querystring';
import { navigate } from '@reach/router';
const nimApi = apiHolder.api.requireLogicalApi('NIM');
export const openSession = async (params, options) => {
    params.mode = params.mode || 'normal';
    const [scene, to] = params.sessionId.split('-');
    options = Object.assign({ createSession: false, validateTeam: false }, options);
    await nimApi.currentSession.setSession({
        scene,
        to,
    }, {
        validateTeam: options.validateTeam,
        tryCreateSession: !!options.createSession,
    });
    navigate('#message?' + qs.stringify(params));
};
export const closeSession = async () => {
    navigate('#message');
};
export const getParams = (str, name) => {
    const reg = new RegExp(`${name}=([^\\?&]+)(?=(&|$))`);
    if (str.match(reg)) {
        return str.match(reg)[1];
    }
    return null;
};
